export default {
  BUTTON: {
    APPLY: "Anwenden",
    NONE: 'None',
    SAVE_CHANGES: "Änderungen speichern",
    PROCEED: "Fortfahren",
    DISMISS: "Verwerfen",
    CONNECT: "Verbinden",
    CONNECT_WALLET: "Wallet verbinden",
    DISCONNECT: "Verbindung trennen",
    LOGOUT: "Abmelden",
    CLOSE: "Schließen",
    SETTINGS: "Einstellungen",
    LAUNCH_APP: "App starten",
    CONNECT_TO_PROCEED: "Wallet verbinden",
    VIEW_DETAILS: "Details anzeigen",
    REFRESH: "Aktualisieren",
    START_REGISTRATION: "Registrierung starten",
    CANCEL: "Abbrechen",
    PRESS_ENTER: "Drücke Enter",
    LEARN_MORE: "Mehr erfahren",
    CLOSE_WINDOW: "Fenster schließen",
    SHOW_AVAILABLE_ONLY: "Nur verfügbare anzeigen",
    SHOW_AVAILABLE: "Nur verfügbare anzeigen",
    PROCEED_SEARCH: "Suche fortsetzen",
    DOWNLOAD: 'Download',
    SHOW_ALL: "Alle anzeigen",
    DESELECT_ALL: "Alle abwählen",
    SHOW_SELCTED: "Ausgewählte anzeigen",
    LINK: 'Link',
    CUSTOM_LINK: "Eigener Link",
    SET_QR_LINK_ALL: "QR-Link alle setzen",
    SET_QR_LINK: "QR-Link alle setzen",
    DISABLE_ALL: "Alle deaktivieren",
    DISABLE_QR_CODE: "QR-Code deaktivieren",
    ENABLE_QR_CODE: "QR-Code deaktivieren",
    SET_QR_COLOR: "QR-Farbe festlegen",
    SET_COLOR: "QR-Farbe festlegen",
    SET_ALL_COLORS: "QR-Farbe festlegen",
    SET_PRICE: "Preis festlegen",
    SET_PRICE_ALL: "Preis alle festlegen",
    RESET: 'Reset',
    CHECK_PROFILE: "Profil prüfen",
    GO_TO_DASHBOARD: "Zum Dashboard gehen",
    GO_TO_HOME: "Gehe zu Home",
    VIEW_PROFILE: "Profil anzeigen",
    CHECK_DOMAINS: "Domänen überprüfen",
    TRANSACTION_DETAILS: "Transaktionsdetails",
    BUY_NOW: "Jetzt kaufen",
    CLEAR_HISTORY: "Verlauf löschen",
    DEFAULT: "Standard",
    CUSTOM: "Benutzerdefiniert",
    FRACTIONALISE: "Zersplittern",
    MORE_INFO: "Weitere Informationen",
    LESS_INFO: "Weniger Infos",
    APPROVE: "Genehmigen",
    NEXT: "Nächste",
    PENDING: "Ausstehend",
    REMOVE: "Entfernen",
    REMOVE_ALL_ITEMS: "Alle Waren entfernen",
    ADD_ALL_TO_CART: "Alle zum Warenkorb hinzufügen",
    BOOKMARK_ALL: "Alle Tabs als Lesezeichen",
    DOWNLOAD_LIST: "Übersicht",
    SHARE_LIST: "Liste teilen",
    MORE: "Mehr",
    CHANGE: "Verändern",
    TRY_AGAIN: "Nochmals versuchen"
  },
  HEADER: {
    ABOUT: "Über",
    FAQ: "FAQ",
    BACK_TO_HOME: "Zurück zur Startseite",
    HOME: "Zurück",
    CATEGORIES: "Kategorien",
    HELP_SUPPORT: "Hilfe & Support",
    HELP: "Hilfe",
    CANCEL_REGISTRATION: "Registrierung abbrechen",
    PROFILE: "Profil",
    SETTINGS: "Einstellungen",
    DOCS: "Texte",
    DOCUMENTATIONS: "Dokumentationen",
    CART: "Warenkorb",
    BOOKMARKS: "Lesezeichen",
    PAYMENTS_HISTORY: "Zahlungsverlauf",
    LIGHT_MODE: "Heller Modus",
    CUSTOM_RPC: "Eigener RPC",
    SETUP_REQUIRED: "Einrichtung erforderlich",
    MANAGE_DOMAINS: "Verwaltung von Domains",
    APPROVE: "Genehmigen",
    FEATURE_DISABLED: "Funktion gesperrt",
    ERROR: "Fehler"
  },
  IPFS: {
    INITIALISING: "Starte p2p",
    FINDING_PEERS: "Suche Partner",
    FAILED: "Fehler",
    READY: "Bereit",
    PUBLISHING: "Veröffentlichen"
  },
  EVENTS: {
    TRANSFER: "Überweisung",
    REGISTRATION: "Anmeldung",
    RENEWAL: "Erneuern",
    SALE: "Verkauf",
    MINT: "Minze",
    BURN: "Verbrennen"
  },
  GENERIC: {
    NETWORK_CHANGED_INCOMPATIBLE: "Netzwerk wird nicht unterstützt. Bitte Netzwerk wechseln.",
    IPNS_PUBLISHING_COMPLETED: "Veröffentlichung abgeschlossen!",
    PENDING_TRANSACTION_CERATED: "Eine neue Transaktion wurde erstellt. Bitte überprüfen Sie Ihre Wallet."
  },
  RENEWAL_DURATIONS: {
    ONE_WEEK: "1 Woche",
    ONE_MONTH: "1 Monat",
    THREE_MONTHS: "3 Monate",
    SIX_MONTHS: "6 Monate",
    ONE_YEAR: "1 Jahr",
    TWO_YEARS: "2 Jahre",
    THREE_YEARS: "3 Jahre",
    FOUR_YEARS: "4 Jahre",
    FIVE_YEARS: "5 Jahre"
  },
  LABELS: {
    DOWNLOAD_DATA: "Daten herunterladen",
    SORT_BY_EXPIRATIONS: "Nach Ablaufdatum sortieren",
    SORT_BY_LATEST_REGISTRATIONS: "Nach neuesten Anmeldungen sortieren",
    SORT_BY_LONGEST_DURATION: "Nach längster Reg. Dauer sortieren",
    PREMIUM: 'Premium',
    ANALYTICS: "Analyse",
    AN_ERROR_HAS_OCCURED: "Bei der Bearbeitung Ihrer Anfrage ist ein Fehler aufgetreten.",
    STOREFRONT_READY_TO_DEPLOY: "Ihre Shop-Front ist bereit zum Aussetzen. Ihr Shop wird sich hier befinden:",
    ACCESS_STOREFRONT: "Sie können nun auf Ihre Shop-Front zugreifen:",
    BUY_ON: "Kaufen auf",
    MY_PROFILE: "Mein Profil",
    CREATE_STOREFRONT: "Schaufenster erstellen",
    SETUP_PRIMARY_DOMAIN: "Primäre Domain einrichten",
    CHOOSE_A_PRIMARY_DOMAIN: "Wählen Sie eine primäre Domain aus und verknüpfen Sie sie mit Ihrem Profil. Diese gewählte Domain wird Ihr Profillink sein.",
    CREATE_YOUR_STOREFRONT: "Erstellen Sie Ihr Shop-Frontend mit Ihrem .eth Namen mit Predomain Stores. Erfahren Sie mehr über Ihr Shop-Front:",
    THIS_DOMAINS_IS_AVAILABLE_IN_MARKETPLACE: "Diese Domain ist auf den folgenden Marktplätzen verfügbar",
    PURCHASE_DOMAINS: "Domains kaufen",
    OWNED_BY: "Im Besitz von",
    SETUP_STOREFRONT: 'Setup Storefront',
    MANAGE_FEATURED_ITEMS: "Empfohlene Elemente verwalten",
    VISIT_STOREFRONT: "zur Shopansicht",
    OPTIONS: "Optionen",
    FEATURED_ITEMS: "Empfohlene Erweiterungen",
    SORT_BY_CATEGORY: "Nach Kategorie sortieren",
    SELECT_DOMAIN: "Domain auswählen",
    SELECT_DOMAINS: "Domänen auswählen",
    RENEW_DOMAINS: "Domains erneuern",
    TRANSFER_DOMAINS: "Transfer-Domänen",
    BUYER: "Käufer",
    PRICE: "Preis",
    SALE: "Verkauf",
    ACTIVITY: "Aktivität",
    TOP_CATEGORIES: "Top-Kategorien",
    TOTAL_ASSETS: "Aktivitäten (Gesamt)",
    MONTHLY_SALES: "Monatsumsatz",
    DAILY_VOLUME: "Tägliches Volumen",
    MONTHLY_VOLUME: "Monatliche Lautstärke",
    DAILY_SALES: "Tagesumsatz",
    TOP_SALE: "Top Verkauf",
    TOP_SALES: "Top Verkäufe",
    TOP_BUYER: "Top-Käufer",
    RECENT_SALES: "Neueste Verkäufe",
    SALES_ACTIVITY: "Verkaufsaktivität",
    ENTER_NAMES_TO_SEARCH: "Namen zum Suchen eingeben",
    NOT_AVAILABLE: "Nicht verfügbar",
    VOLUME: "Lautstärke",
    FLOOR: "Boden",
    FILTER: 'Filter',
    RENEWAL_DURATION: "Erneuerungsdauer",
    TRANSACTION: "Überweisung",
    USER_PROFILE: "Benutzerprofil",
    FEATURE_DISABLED: "Diese Funktion ist derzeit deaktiviert.",
    COMPLETE: 'Complete',
    ESTIMATED_COST: "Geschätzte Kosten",
    ADDRESS: "Adresse",
    TRANSFER: "Überweisung",
    PLEASE_WAIT: "Bitte warten",
    SELECT_A_DOMAIN: "Domain auswählen",
    RENEW: 'Renew',
    MANAGE_DOMAINS: "Verwaltung von Domains",
    SEARCH_FOR: "Suche nach",
    MANAGE: "Verwalten",
    COLLECT: "Einsammeln",
    LANDING_TEXT: "Open-Source, dezentralisiert, Web3 Domains Suche, Registrierung & Marktplatz.",
    PROFILE: "Profil",
    GO_TO_PROFILE: "Gehen Sie zum Profil",
    SEARCH: "Suchen",
    CONTAIN_ALPHABET: "Enthält Alphabet",
    CONTAIN_NUMBERS: "Enthält Zahlen",
    CONTAIN_EMOJI: "Enthält Emoji",
    MIN_LENGTH: "Min. Länge",
    MAX_LENGTH: "Max. Länge",
    CONTAINING_KEYWORDS: "Enthält Stichwörter",
    FILTERS: "Filtern",
    DOMAINS: 'Domains',
    DOMAIN: "Bedeutungsfeld",
    DOMAIN_HISTORY: "Domänengeschichte",
    EXPIRATION_DATE: "Verfallsdatum",
    REGISTRATION_DATE: "Anmeldung",
    CREATION_DATE: "Erstellungsdatum",
    DETAILS: 'Details',
    YOUR_DOMAINS: "Ihre Domains",
    PROCESSING: "Verarbeitung",
    LAYOUT: 'Layout',
    ENTER_SUFFIX: "Suffix eingeben",
    ENTER_PREFIX: "Präfix eingeben",
    CLICK: 'Click',
    CONNECT_TO_START: " loslegen oder ",
    TIP: 'Tip',
    ACTION: "Aktion",
    ACTIONS: "Aktionen",
    ADVANCED_SEARCH_TIP: "verwenden Sie neue Zeile oder Kommas um Ihre Domain-Einträge zu trennen.",
    ADVANCED_SEARCH: "Erweiterte Suche",
    ADVANCED_MODE: "Erweiterter Modus",
    REGISTER_DOMAINS_TO: "Domains registrieren zu",
    NO_DOMAINS_SELECTED: "Keine Domains ausgewählt.",
    FIND_AND_REGISTER: "Registrieren Sie Domains z.B. domain1, domain2...",
    SELECTED_DOMAINS: "Ausgewählte Domains",
    REGISTER: "Registrieren",
    BOOKMARKS: "Lesezeichen",
    SEARCH_RESULTS: "Suchergebnisse",
    PROCEED_TO_REGISTRATION: "Zur Registrierung fortfahren",
    REGISTER_DOMAINS: "Domains registrieren zu",
    REGISTRANT_ADDRESS: "Adresse des Interessenten",
    SET_RESOLVER: "Auflöser setzen",
    TOTAL_COST: "Gesamtkosten",
    GAS_PRICE: "Gaspreis",
    NO_ADDRESS_DETECTED: "Keine Adresse erkannt.",
    DURATION: "Dauer",
    NOTICE_SELECT_AN_RPC: "Hinweis: Wählen Sie einen RPC, der in der Anwendung verwendet wird, um den Standard-RPC-Anbieter zu ersetzen.",
    ENABLE_LIGHT_MODE: "Licht-Layout-Stil aktivieren.",
    CLICK_NEXT_TO_PROCEED: "Klicke <b>weiter</b> um fortzufahren."
  },
  REGISTRATION: {
    REGISTRATION_CANCELLED_TITLE: "Registrierung abgebrochen",
    REGISTRATION_CANCELLED_DESCRIPTION: "Ihre Anmeldung wurde abgebrochen.",
    CANCEL_REGISTRATION_TITLE: "Registrierung abbrechen",
    CANCEL_REGISTRATION_DESCRIPTION: "Sind Sie sicher, dass Sie diese Registrierung abbrechen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    BEFORE_COMMIT: "Schritt 1: Registrierung anfordern.",
    COMMIT_SENT: "Anfrage wird verarbeitet...",
    COMMIT_COMPLETE: "Schritt 1: Registrierung anfordern...",
    AWAIT: "Anfrage wird verarbeitet...",
    BEFORE_REGISTRATION: "Vollständige Registrierung.",
    REGISTRATION_SENT: "Registrierung wird abgeschlossen...",
    REGISTRATION_COMPLETE: "Anmeldung!",
    REGISTRATION_COMPLETE_TITLE: "Anmeldung",
    YOUR_DOMAINS_HAVE_NOW_BEEN_REGISTERED: "Ihre Domains wurden jetzt registriert.",
    BASKET_EMPTY: "Ihr Warenkorb ist leer",
    PLEASE_SELECT_DOMAINS_TO_REGISTER: "Bitte wählen Sie neue Domains zum Registrieren aus."
  },
  PAYMENT: {
    PAYMENT_CANCELLED: "Transaktion abgebrochen. Bitte versuchen Sie es erneut."
  },
  SPINNER: {
    SETUP_COMPLETE: "Setup erfolgreich",
    LEDGER_NO_DEVICE_SELECTED: "Beim Verbinden mit Ihrer Wallet ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    NO_DATA_TO_DISPLAY: "Keine Elemente zum Anzeigen.",
    PERFORMING_SEARCH: "Suche wird durchgeführt...",
    LOADING_DATA: "Lade Daten...",
    FOLLOW_THE_INSTRUCTIONS_ON_YOUR_WALLET: "Bitte folgen Sie den Anweisungen in Ihrer Brieftasche um fortzufahren."
  },
  FORM_LABELS: {
    ENTER_DURATION: "Dauer eingeben",
    ENTER_QR_LINK: "Eigene QR-Code URL eingeben",
    ENTER_PRICE: "Preis eingeben",
    ENTER_CUSTOM_ADDRESS: "Eigene Adresse eingeben",
    ENTER_RECEIVER_ADDRESS: "Empfängeradresse eingeben"
  },
  FORM_ERRORS: {
    INVALID_DURATION: "Ungültige Dauer",
    INVALID_QR_LINK: "Ungültige URL, bitte versuchen Sie es erneut.",
    INVALID_PRICE: "Ungültiger Preis, bitte versuchen Sie es erneut.",
    NO_ADDRESS_DETECTED: "Keine Adresse erkannt, bitte versuchen Sie es erneut.",
    INVALID_ADDRESS: "Ungültige Adresse, bitte versuchen Sie es erneut."
  },
  STEP: {
    STEP_1: "Schritt 1",
    STEP_2: "Schritt 2",
    STEP_3: "Schritt 3",
    STEP_4: "Schritt 4",
    STEP_5: "Schritt 5"
  },
  RENEW: {
    RENEWAL_COST: "Erneuerungskosten",
    ESTIMATED_RENEWAL_COST: "Unten sind die geschätzten Erneuerungskosten für diese Transaktion.",
    RENEWAL_COMPLETE: "Erneuerung abgeschlossen",
    DOMAINS_READY_FOR_RENEWAL: " Ihre Domains sind nun fertig Erneuerung. Um Ihre Erneuerung abzuschließen, fahren Sie fort."
  },
  TRANSFER: {
    TRANSFER_TO: "Weiter in",
    TRANSFER_COMPLETE: "Übertragung abgeschlossen!",
    SETUP_INSTRUCTION: "Um die ENS-Domains-Verwaltung zu aktivieren, muss Ihr Konto so konfiguriert sein, dass es die Übertragung von Domains genehmigt.",
    CONTRACT_APPROVAL_NOTE: "Die Vertragsgenehmigung ermöglicht es dem Vertrag, die Übertragung von Domains in Ihrem Namen durchzuführen.",
    DOMAINS_READY_FOR_TRANSFER: "Deine Domains sind jetzt zur Übertragung bereit. Gib die Empfängeradresse ein und drücke auf Fortfahren."
  }
};